var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"csv-wrap"},[_c('form',{attrs:{"id":"msform"}},[_c('fieldset',[_c('uploadFile',{attrs:{"type":"csv"},on:{"uploadFile":_vm.uploadFile,"importFile":_vm.importFile}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }